
import { Route } from '@/app/router'

const Users = () => import('./index.vue')

const UsersMeta = {
	sort: 11,
	displayInSidebar: true,
	displayName: 'user',
	icon: 'fal user-alt',
	activeIcon: 'fas user-alt'
}

const UsersProps = ['page', 'perPage']

export default new Route('/users', Users)
	.as('Dashboard:Users')
	.meta(UsersMeta)
	.props(UsersProps)
	.permissions(['VIEW_USERS'])
